import { useMutation } from 'react-query';
import { validateEmail } from 'queries/auth';

const useValidateEmail = () => {
  return useMutation((email: string) => validateEmail({ email }));
};

export default useValidateEmail;
